import React from 'react';
import { View, Text, ScrollView, StyleSheet, StatusBar, SafeAreaView, Platform } from 'react-native';

const HEADER_HEIGHT = 60;

const Test = () => {
  return (
    <SafeAreaView style={styles.container}>
      {/* StatusBar to avoid header being covered */}
      <StatusBar barStyle="light-content" />

      {/* ✅ Fixed Header */}
      <View style={styles.header}>
        <Text style={styles.headerText}>Fixed Header</Text>
      </View>

      {/* ✅ Scrollable Content */}
      <ScrollView contentContainerStyle={styles.scrollViewContent}>
        <Text style={styles.title}>Scroll Below</Text>
        {Array.from({ length: 50 }).map((_, idx) => (
          <Text key={idx} style={styles.item}>Line {idx + 1}</Text>
        ))}
      </ScrollView>
    </SafeAreaView>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#fff',
  },
  header: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    height: HEADER_HEIGHT,
    backgroundColor: '#6200EE',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 10, // Make sure header stays on top
    elevation: 4, // Add shadow for Android
    paddingTop: Platform.OS === 'ios' ? 20 : 0, // extra padding for iOS
  },
  headerText: {
    color: '#fff',
    fontSize: 18,
    fontWeight: 'bold',
  },
  scrollViewContent: {
    marginTop: HEADER_HEIGHT, // Start the scrollable content after the header
    paddingHorizontal: 20,
    paddingBottom: 100,
  },
  title: {
    fontSize: 24,
    fontWeight: 'bold',
    marginBottom: 16,
  },
  item: {
    fontSize: 16,
    marginBottom: 10,
  },
});

export default Test;
